/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/ModeModel.js" />

var ProductContentModeModel = function (pageModelHndl) {
    var that = this;

    that.SelectedMode = ko.observable(new ModeModel(pageModelHndl));

    //baseData
    that.SelectedModeId = ko.observable();
    that.AvailableModes = ko.observableArray([]);
    that.IsBeginnerModeSelected = ko.computed(function() {
        return that.SelectedModeId() === "MODE_0";
    }, that);
    that.IsStandardModeSelected = ko.computed(function () {
        return that.SelectedModeId() === "MODE_1";
    }, that);
    that.IsExpertModeSelected = ko.computed(function () {
        return that.SelectedModeId() === "MODE_2";
    }, that);

    that.EnabledModes = ko.computed(function () {
        var modes = [];
        $.each(that.AvailableModes(), function (i, m) {
            if (m.IsEnabled() === true) {
                modes.push(m);
            }
        });
        return modes;
    });

    that.SetModeId = function (mode) {
        that.SelectedModeId(mode.ModeId());
    };

    //supscriptions
    that.SelectedModeId.subscribe(function (selectedModeId) {
        $.each(that.AvailableModes(), function (i, aMode) {
            if (aMode.ModeId() === selectedModeId) {
                aMode.IsSelected(true);
            }
            else {
                aMode.IsSelected(false);
            }

            if ((i === that.AvailableModes().length - 1) && (pageModelHndl.IsProductModelPopulated())) {
                if (that.SelectedModeId() === "MODE_0") {
                    pageModelHndl.pPriceTableModelV2.ShowLessPrices(true);
                    pageModelHndl.pPriceTableModelV2.SetBeginnerMode();
                    pageModelHndl.pSummaryModel.SetBeginnerMode();
                } else {
                    pageModelHndl.pPriceTableModelV2.ShowMorePrices(false);
                    pageModelHndl.pPriceTableModelV2.RemoveBeginnerMode();
                    pageModelHndl.pSummaryModel.RemoveBeginnerMode();
                }
                pageModelHndl.pProductModel.UpdateBeginnerMode();
            }
        });

        if(userSettings.isProductOverviewBs4Enabled) {
            // only required for bs4 layout
            $(function () {
                $('[data-toggle="tooltip"]').tooltip();
            });
        }
        $(document).trigger('gridLayoutIeApply');
    });

    that.SetAvailableModes = function () {
        $.each(modeIds, function (i, modeId) {
            var modeModel = new ModeModel(pageModelHndl);

            modeModel.ModeId(modeIds[i]);
            modeModel.DisplayText(modeNames[i]);
            modeModel.IsEnabled(modeEnabled[i]);

            that.AvailableModes.push(modeModel);

            if (i == (modeIds.length - 1)) {
                that.SelectedModeId($("#hfInitialModeId").val());
            }
        });
    };
};
